/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { EVENT_BASE_URL } from "../Constants/SagaConstants";
import { IEventDataResult } from "../Interfaces/Event/IEventDataResult";
import { IEventsDataResult } from "../Interfaces/Event/IEventsDataResult";
import { IEventsRequest } from "../Interfaces/Event/IEventsRequest";
import { IEventStatus } from "../Interfaces/Event/IEventStatus";
import { IEventUpdateStatusDataResult } from "../Interfaces/Event/IEventUpdateStatusDataResult";
import { IApiResult2 } from "../Interfaces/IApiResult";
import { get, post, put, IHttpResponse } from "./ApiUtils";

/**
 * Get full detail of individual event
 */
export async function getEvent(
  selectedEventId: string
): Promise<IHttpResponse<IApiResult2<IEventDataResult>>> {
  return await get<IApiResult2<IEventDataResult>>(EVENT_BASE_URL + selectedEventId, true);
}

/**
 * Search all events for the given text.
 */
export async function searchEvents(
  searchRequest: IEventsRequest
): Promise<IHttpResponse<IApiResult2<IEventsDataResult>>> {
  return await post<IApiResult2<IEventsDataResult>>(EVENT_BASE_URL + "search", searchRequest, true);
}

/**
 * Update an event's status
 */
export async function updateEventStatus(
  eventStatus: IEventStatus
): Promise<IHttpResponse<IApiResult2<IEventUpdateStatusDataResult>>> {
  return await put<IApiResult2<IEventUpdateStatusDataResult>>(
    EVENT_BASE_URL + "UpdateEventStatus/",
    eventStatus,
    true
  );
}
